module.exports = __webpack_public_path__ + "img/a3eb31d.jpg";